import { DonateBoxButtons, DonateBoxButtonsProps } from '@/app/components/DonateBoxDobro/components/DonateBoxButtons';
import { useIsUserInFloatingButtonGroup } from '@/app/hooks/useIsUserInFloatingButtonGroup';
import { useIsUserInNewHeaderLayoutGroup } from '@/app/hooks/useIsUserInNewHeaderLayoutGroup';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

type DonateButtonsContainerProps = Omit<DonateBoxButtonsProps, 'shareButtonText'> & {};

export const DonateBoxContainer = (donateBoxButtonsProps: DonateButtonsContainerProps) => {
  const isUserInFloatingButtonGroup = useIsUserInFloatingButtonGroup();
  const blockButtonsRef = useRef<HTMLDivElement>(null);
  const [isBlockVisible, setIsBlockVisible] = useState(true);
  const isUserInNewHeaderLayoutGroup = useIsUserInNewHeaderLayoutGroup();
  const { t } = useTranslation();
  const isBlockButtonsInCurrentView = () => {
    if (!blockButtonsRef.current) {
      return false;
    }

    const rect = blockButtonsRef.current.getBoundingClientRect();

    const isScrolledBehindButtons = rect.top >= 0;

    return isScrolledBehindButtons;
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsBlockVisible(isBlockButtonsInCurrentView());
    };

    handleScroll(); // check on mount
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  const isFixedButtonsVisible = !isBlockVisible;

  return (
    <div>
      {isFixedButtonsVisible && (
        <div
          className={classNames(
            'fixed !w-full left-0 bottom-0 px-[24px] shadow-lg z-20',
            isUserInFloatingButtonGroup
              ? 'bottom-0 bg-secondary-light'
              : 'left-0 h-[84px] justify-center top-0 px-[24px] shadow-lg bg-white z-20',
          )}
        >
          <DonateBoxButtons
            donateButtonTestId="fixed-donate-button"
            {...donateBoxButtonsProps}
            shareButtonText={t('components.DonateBox.share')}
            shouldBeButtonsLarge={isUserInFloatingButtonGroup}
          />
        </div>
      )}
      <div className={isUserInFloatingButtonGroup ? 'my-[20px]' : ''}>
        <DonateBoxButtons
          donateButtonTestId="static-donate-button"
          ref={blockButtonsRef}
          {...donateBoxButtonsProps}
          shareButtonText={
            isUserInNewHeaderLayoutGroup ? t('components.DonateBox.shareStory') : t('components.DonateBox.share')
          }
          shouldBeButtonsLarge={isUserInNewHeaderLayoutGroup}
          className={classNames(
            isUserInNewHeaderLayoutGroup && 'flex-col gap-[8px]',
            !isUserInFloatingButtonGroup && 'py-[20px]',
          )}
        />
      </div>
    </div>
  );
};
